import React from 'react'
import logo from '../../resources/logo.svg'
import SwitchLanguage from '../common/SwitchLanguage/SwitchLanguage'
import { useLocation } from 'react-router-dom'
import { Button } from 'antd'
import $t from '../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../actions'
import routes from 'consts/routes'
import { LAYOUT_TYPE, DIALOG_TYPE } from 'consts'

import './Header.css'

export const Header = ({ isSaveAvailable }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const isSaveRequsted = useSelector(state => state.app.isSaveRequsted)
  const isHomeRoute = location.pathname === routes.ROOT
  const layout = useSelector(state => state.app.layout)

  const isBroker = useSelector(state => state.app.layout === LAYOUT_TYPE.broker)
  const brokerFirstName = useSelector(state => state.broker.firstName)
  const brokerLastName = useSelector(state => state.broker.lastName)

  const openSaveDialog = () => {
    const { SHARE_APPLICATION, SAVE_PROGRESS } = DIALOG_TYPE
    const dialogType = isBroker ? SHARE_APPLICATION : SAVE_PROGRESS
    dispatch(
      Actions.createAction(Actions.SAVE_DIALOG_OPEN_CLICKED, {
        type: dialogType
      })
    )
  }

  return (
    <div className='header'>
      <div className='logo-container'>
        <img
          data-name={'logo'}
          src={logo}
          alt=''
          className='logo-img trackable'
          onClick={() => {
            dispatch(
              Actions.createAction(Actions.NAVIGATED_HOME, {
                layout
              })
            )
          }}
        />
        {isBroker && (
          <div className='broker-label'>
            <i className='icon-personal-card space' />
            <span className='semi-bold space'>{$t('common.broker')}</span>{' '}
            {brokerFirstName && (brokerFirstName)}{' '}{brokerLastName && (brokerLastName)}
          </div>
        )}
      </div>
      {/*UNMARK AFTER 1.1 RELEASE*/}
      {/* {isHomeRoute && !isBroker && (
        <Button
          type='text'
          data-name='for agents'
          className='for-agent-button header-button trackable'
          onClick={() => window.open(BROKER_PORTAL_LINK, '_self')}
        >
          {$t('home.forAgents')}
        </Button>
      )} */}
      {isSaveAvailable && (
        <Button
          type='text'
          data-name='save-progress'
          className='save-progress-button header-button trackable'
          loading={isSaveRequsted}
          onClick={openSaveDialog}
        >
          {isBroker
            ? $t('dialogs.shareApplication.shareProgress')
            : $t('dialogs.saveProgress.saveProgress')}
        </Button>
      )}
      <div className='switch-language'>
        <SwitchLanguage />
      </div>
    </div>
  )
}

export default Header
